package fyi.moko.hotpl.domain.usecase

import fyi.moko.hotpl.domain.model.Friend
import fyi.moko.hotpl.domain.service.AuthService
import fyi.moko.hotpl.domain.service.SocialGraphService
import kotlinx.coroutines.ExperimentalCoroutinesApi
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.flatMapLatest
import kotlinx.coroutines.flow.flowOf
import kotlinx.coroutines.flow.map

/**
 * The current user's friends, live. Re-attaches the listener when the account
 * switches ([AuthService.currentUserId] emits a new uid) and goes empty while
 * signed out.
 */
class ObserveFriendsUseCase(
    private val authService: AuthService,
    private val socialGraphService: SocialGraphService,
) {
    @OptIn(ExperimentalCoroutinesApi::class)
    operator fun invoke(): Flow<List<Friend>> =
        authService.currentUserId.flatMapLatest { uid ->
            if (uid == null) {
                flowOf(emptyList())
            } else {
                socialGraphService.observeFriendships(uid)
                    .map { friendships -> friendships.map { it.toFriend(uid) } }
            }
        }
}
